import React, { useState } from 'react';

const RegisterModal = ({ isOpen, onClose }) => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    imageUrl: '',
    mobileNumber: '',
    highestQualification: '',
    city: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch('https://techwala-api-production.up.railway.app/students', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      alert('Student registered successfully!');
      onClose();
    } catch (err) {
      alert('Registration failed.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      <form className="modal-content" onSubmit={handleSubmit}>
        <h2>Enroll Student</h2>
        <input name="name" placeholder="Name" onChange={handleChange} required />
        <input name="email" placeholder="Email" onChange={handleChange} required />
        <input name="imageUrl" placeholder="Image URL" onChange={handleChange} />
        <input name="mobileNumber" placeholder="Mobile Number" onChange={handleChange} required />
        <input name="highestQualification" placeholder="Highest Qualification" onChange={handleChange} />
        <input name="city" placeholder="City" onChange={handleChange} />
        <button type="submit">Submit</button>
        <button type="button" onClick={onClose}>Cancel</button>
      </form>
    </div>
  );
};

export default RegisterModal;
